export default "__VITE_ASSET__DGmDR0fq__"